import type { AdminProfile, UpdateAdminProfilePayload } from '../entities/admin_profile.entity'
import type { ProfileRepository } from '../repositories/profile_repository'

export class UpdateAdminProfileUseCase {
  constructor(private readonly repository: ProfileRepository) {}

  execute(payload: UpdateAdminProfilePayload): Promise<AdminProfile> {
    return this.repository.updateMe(payload)
  }
}
